import React from "react";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import ModalDialogTitle from "./ModalDialogTitle";

/**
 * Standard "are you sure you want to delete this?" confirmation dialog.
 * Closes via the X only (no Cancel button) — the single action is a red
 * trash-icon Delete button that confirms the deletion.
 */
const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  deleting = false,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this record? This action cannot be undone.",
}) => (
  <Dialog open={open} onClose={onClose}>
    <ModalDialogTitle onClose={onClose}>{title}</ModalDialogTitle>
    <DialogContent>{message}</DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        startIcon={
          deleting ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <DeleteIcon />
          )
        }
        disabled={deleting}
      >
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteDialog;
